var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t("accountSuccess.title")))]),_c('div',[_vm._v(_vm._s(_vm.$t("accountSuccess.subTitle")))]),_c('div',[_vm._v(" "+_vm._s(_vm.$t("accountSuccess.description"))+" ")])]),_c('img',{attrs:{"src":"/subscribe.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }